export abstract class ApplicationError extends Error {
  public originalError: any;
  public userMessage: string;

  constructor(name: string, message: string, userMessage: string, originalError: any = null) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = name;
    this.originalError = originalError;
    this.userMessage = userMessage;
  }
}
